// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7a2491a8-abd7-4030-9686-3bf7ca8396aa',
      type: 'Sprite',
      name: 'buttonBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Main_Menu_Icon_Background',
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7',
      type: 'Container',
      name: 'wheelContainer',
      className: '',
      x: 0,
      y: 57,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      stateByName: {
        NoSpin: {
          angle: 0,
          scale: {
            y: 1,
            x: 1
          }
        }
      }
    },
    {
      id: '39cee8cb-e165-4fd2-979e-f699ea88a3da',
      type: 'Container',
      name: 'freePanelContainer',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      stateByName: {
        FreeSpin: {
          visible: true
        },
        AdSpins: {
          visible: false
        },
        NoSpin: {
          visible: false
        }
      }
    },
    {
      id: 'a20b1882-9b56-47b7-a08c-7c7f5ab4d9ee',
      type: 'Container',
      name: 'adPanelContainer',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      stateByName: {
        FreeSpin: {
          visible: false
        },
        AdSpins: {
          visible: true
        },
        NoSpin: {
          visible: false
        }
      }
    },
    {
      id: 'c31156c2-de46-4a1b-99b9-94a85653e9dd',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be',
      stateByName: {
        FreeSpin: {
          visible: false
        },
        AdSpins: {
          visible: false
        },
        NoSpin: {
          visible: true
        }
      }
    },
    {
      id: '0508d988-ea53-4ca8-996e-ee697f43f40a',
      type: 'Container',
      name: 'notificationDot',
      className: '',
      x: 59,
      y: -31,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f7df203c-d5ff-434b-8f2d-cbc976d981be'
    },
    {
      id: 'be22ed04-46aa-457c-9906-a9df707144b0',
      type: 'Sprite',
      name: 'sections',
      className: '',
      x: 0,
      y: -59,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Main_Menu_Icon_Sections',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7',
      stateByName: {
        NoSpin: {
          angle: 0
        }
      }
    },
    {
      id: 'b10dba1c-e8c7-4a2c-96ea-887f373628f3',
      type: 'Sprite',
      name: 'frame',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Main_Menu_Icon_Frame',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'd166890e-668c-4aef-b3b2-fd440d7fd60c',
      type: 'Sprite',
      name: 'pointer',
      className: '',
      x: 0,
      y: -110,
      anchor: {
        x: 0.5,
        y: 0.36
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Main_Menu_Icon_Pointer',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7',
      stateByName: {
        NoSpin: {
          angle: 0
        }
      }
    },
    {
      id: 'c5b1ada1-7d82-431e-b28e-329992211823',
      type: 'Sprite',
      name: 'light1Left',
      className: '',
      x: -29,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'd64a4d95-a8cd-4baf-bdb3-fa846a829a22',
      type: 'Sprite',
      name: 'light1Right',
      className: '',
      x: 29,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '2072b44a-9980-47d3-a91b-ccd7b4b5d680',
      type: 'Sprite',
      name: 'light2Left',
      className: '',
      x: -41,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'e3c9c2ea-ed82-4db9-bcca-c1d0fa814887',
      type: 'Sprite',
      name: 'light2Right',
      className: '',
      x: 41,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'd9827045-cdb4-41b6-b2c5-3764c2cd3e0c',
      type: 'Sprite',
      name: 'light3Left',
      className: '',
      x: -51,
      y: -28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '84f26d12-ea21-440c-a21b-fc604623481b',
      type: 'Sprite',
      name: 'light3Right',
      className: '',
      x: 51,
      y: -28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '6b54c97e-2d72-4071-adcc-36bd7c249034',
      type: 'Sprite',
      name: 'light4Left',
      className: '',
      x: -57,
      y: -43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '266017c9-149b-4e5e-bc95-6821a77c82d1',
      type: 'Sprite',
      name: 'light4Right',
      className: '',
      x: 57,
      y: -43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '8b558ea8-4b50-46ce-80b2-06f06ab9b213',
      type: 'Sprite',
      name: 'light5Left',
      className: '',
      x: -59,
      y: -57,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '733d1a83-d9f7-4e54-a068-3be9c9193d3d',
      type: 'Sprite',
      name: 'light5Right',
      className: '',
      x: 59,
      y: -57,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'b9a06d6d-aed6-4a20-92f7-990881facd0b',
      type: 'Sprite',
      name: 'light6Left',
      className: '',
      x: -57,
      y: -73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '4b7e3997-2899-40d7-827c-d567f3687e32',
      type: 'Sprite',
      name: 'light6Right',
      className: '',
      x: 57,
      y: -73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: 'ce0cda16-493d-4131-a0c7-0115acabfcc9',
      type: 'Sprite',
      name: 'light7Left',
      className: '',
      x: -51,
      y: -87,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '963a6521-a623-4353-b5ab-7112897ab3ee',
      type: 'Sprite',
      name: 'light7Right',
      className: '',
      x: 51,
      y: -87,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '8a2c9316-5b71-44b9-b2a6-1301278fbd75',
      type: 'Sprite',
      name: 'light8Left',
      className: '',
      x: -41,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '85b43aa1-800a-4111-a8cc-b17155981678',
      type: 'Sprite',
      name: 'light8Right',
      className: '',
      x: 41,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '592570fd-9c62-4ab4-9805-5891d2e541e9',
      type: 'Sprite',
      name: 'light9Left',
      className: '',
      x: -29,
      y: -109,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '1cdc2c32-a2b2-4509-b865-0453e1766a40',
      type: 'Sprite',
      name: 'light9Right',
      className: '',
      x: 29,
      y: -109,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16768373,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Light',
      parent: '9bbb29b4-0731-43b7-a0bf-0dfe2a7b64a7'
    },
    {
      id: '5b336826-f3cc-4e5e-8717-08df37ad9c21',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Menu_Icon_Join_Button',
      parent: '39cee8cb-e165-4fd2-979e-f699ea88a3da'
    },
    {
      id: '242e84c8-8347-424d-9087-6d1ffdeea365',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Free',
      localize: true,
      maxWidth: 87,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#145036',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#145036',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '39cee8cb-e165-4fd2-979e-f699ea88a3da'
    },
    {
      id: 'b299dc86-ee41-482d-92de-348b81239fab',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Counter_Blue',
      parent: 'a20b1882-9b56-47b7-a08c-7c7f5ab4d9ee'
    },
    {
      id: 'a3a2e808-444c-4ad3-9ff8-10d73ee0f263',
      type: 'Text',
      name: 'adCountText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'X left',
      localize: false,
      maxWidth: 87,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0B41F0',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#145036',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a20b1882-9b56-47b7-a08c-7c7f5ab4d9ee'
    },
    {
      id: 'd114754b-d7fd-45ee-9a27-db25843328c1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Icon_Timer_Background',
      parent: 'c31156c2-de46-4a1b-99b9-94a85653e9dd'
    },
    {
      id: '8f214948-3033-4572-aa8b-54c8625a853d',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1h 20m',
      localize: false,
      maxWidth: 87,
      maxHeight: 44,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6e2009',
        stroke: 'white',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c31156c2-de46-4a1b-99b9-94a85653e9dd'
    },
    {
      id: '54904581-c3e9-4eae-acc9-57e2c18c05ff',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Notification_Dot',
      parent: '0508d988-ea53-4ca8-996e-ee697f43f40a'
    },
    {
      id: '3addcce4-7e5b-4465-ba92-2e618eba2ea3',
      type: 'Text',
      name: 'notificationAmount',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0508d988-ea53-4ca8-996e-ee697f43f40a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    'FreeSpin',
    'AdSpins',
    'NoSpin'
  ],
  animations: [
    {
      id: '1363f341-df14-4514-a8d0-02caafae069a',
      name: 'Free_Spin_Idle',
      playingSpeed: 1,
      totalDuration: 2800,
      blocks: [
        {
          id: '572f462d-af46-42ac-8768-2b977ad87a75',
          type: 'Setter',
          name: 'sectionsRotation',
          track: 6,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'sections',
          disabled: false
        },
        {
          id: '1dc82661-c30b-4d0b-bbbf-acef3a227555',
          type: 'Tween',
          name: 'wheelScale',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 0,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '508eb37a-37ae-405d-8529-fd9a3cdf9054',
          type: 'Tween',
          name: 'pointerRotation',
          duration: 300,
          track: 8,
          target: {
            angle: -60
          },
          startAt: 150,
          sourceName: 'pointer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3da537b7-51b1-4185-9742-24629f8c3647',
          type: 'Tween',
          name: 'wheelPosition',
          duration: 250,
          track: 2,
          target: {
            y: 42
          },
          startAt: 150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6f08af4d-7f5b-4676-b4cf-ac8c309c6870',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '06a43037-3967-47d2-a92a-fa6ad4a11934',
          type: 'Tween',
          name: 'wheelRotation',
          duration: 1750,
          track: 6,
          target: {
            angle: 360
          },
          startAt: 150,
          sourceName: 'sections',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '90091b8a-61fa-4b1d-9867-c9bc65662667',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 350,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'acc9206d-099b-4887-8f93-5bc6573b08de',
          type: 'Tween',
          name: 'wheelPosition_1',
          duration: 250,
          track: 2,
          target: {
            y: 57
          },
          startAt: 400,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5fc0045b-2090-4e43-a503-9c6e9cf656dc',
          type: 'Tween',
          name: 'wheelScale_3',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 550,
          sourceName: 'wheelContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '1d8d6cd3-55b8-4f95-9612-af7263c92114',
          type: 'Tween',
          name: 'wheelScale_4',
          duration: 250,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a89015a0-f204-4f61-ad58-f162cfae6353',
          type: 'Tween',
          name: 'wheelScale_copy',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 1000,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c35f3982-5827-41a8-b421-95510282e413',
          type: 'Tween',
          name: 'wheelPosition_copy',
          duration: 250,
          track: 2,
          target: {
            y: 42
          },
          startAt: 1150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '094bd237-cd19-4e73-8711-354ad21b0e57',
          type: 'Tween',
          name: 'wheelScale_2_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 1150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2e3cfbdf-c9bd-4a9e-b82c-cf5e4a15f5cc',
          type: 'Tween',
          name: 'wheelScale_1_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1350,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7f766889-97e6-478e-8908-abd13bb4be51',
          type: 'Tween',
          name: 'pointerRotation_copy_copy',
          duration: 300,
          track: 8,
          target: {
            angle: 0
          },
          startAt: 1400,
          sourceName: 'pointer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '49a258e3-99b2-4ba2-9a74-bfb84f9353a3',
          type: 'Tween',
          name: 'wheelPosition_1_copy',
          duration: 250,
          track: 2,
          target: {
            y: 57
          },
          startAt: 1400,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3be01320-195a-4744-86a9-f7d35e882d0c',
          type: 'Tween',
          name: 'wheelScale_3_copy',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 1550,
          sourceName: 'wheelContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '092a9dd3-6a11-454a-8198-309561894387',
          type: 'Tween',
          name: 'wheelScale_4_copy',
          duration: 250,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1700,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '9d03ab52-3202-486b-8a72-96a3a2a4dcdc',
      name: 'Ad_Spin_Idle',
      playingSpeed: 1,
      totalDuration: 2800,
      blocks: [
        {
          id: '4f1afaf3-01bb-4b75-b949-20d72924e859',
          type: 'Setter',
          name: 'setPointerAngle',
          track: 2,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'pointer',
          disabled: false
        },
        {
          id: '1dc82661-c30b-4d0b-bbbf-acef3a227555',
          type: 'Tween',
          name: 'wheelScale',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 0,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6f08af4d-7f5b-4676-b4cf-ac8c309c6870',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '90091b8a-61fa-4b1d-9867-c9bc65662667',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 350,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5fc0045b-2090-4e43-a503-9c6e9cf656dc',
          type: 'Tween',
          name: 'wheelScale_3',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 550,
          sourceName: 'wheelContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '1d8d6cd3-55b8-4f95-9612-af7263c92114',
          type: 'Tween',
          name: 'wheelScale_4',
          duration: 250,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a89015a0-f204-4f61-ad58-f162cfae6353',
          type: 'Tween',
          name: 'wheelScale_copy',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 1000,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '094bd237-cd19-4e73-8711-354ad21b0e57',
          type: 'Tween',
          name: 'wheelScale_2_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 1150,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2e3cfbdf-c9bd-4a9e-b82c-cf5e4a15f5cc',
          type: 'Tween',
          name: 'wheelScale_1_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1350,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3be01320-195a-4744-86a9-f7d35e882d0c',
          type: 'Tween',
          name: 'wheelScale_3_copy',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 0.92
            }
          },
          startAt: 1550,
          sourceName: 'wheelContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '092a9dd3-6a11-454a-8198-309561894387',
          type: 'Tween',
          name: 'wheelScale_4_copy',
          duration: 250,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1700,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class LuckyWheelMenuIconLayout {
  static raw = raw;
  root!: Container;
  buttonBackground!: Sprite;
  wheelContainer!: Container;
  freePanelContainer!: Container;
  adPanelContainer!: Container;
  timerContainer!: Container;
  notificationDot!: Container;
  sections!: Sprite;
  frame!: Sprite;
  pointer!: Sprite;
  light1Left!: Sprite;
  light1Right!: Sprite;
  light2Left!: Sprite;
  light2Right!: Sprite;
  light3Left!: Sprite;
  light3Right!: Sprite;
  light4Left!: Sprite;
  light4Right!: Sprite;
  light5Left!: Sprite;
  light5Right!: Sprite;
  light6Left!: Sprite;
  light6Right!: Sprite;
  light7Left!: Sprite;
  light7Right!: Sprite;
  light8Left!: Sprite;
  light8Right!: Sprite;
  light9Left!: Sprite;
  light9Right!: Sprite;
  adCountText!: Text;
  timerText!: Text;
  notificationAmount!: Text;
  upperCase_SPL!: (Text)[];
  StateName!: 'FreeSpin' | 'AdSpins' | 'NoSpin';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Free_Spin_Idle {
  Layout: {
    sections: object;
    wheelContainer: object;
    pointer: object;
  };

  BlockTypeByName: {
    sectionsRotation: object;
    wheelScale: object;
    pointerRotation: object;
    wheelPosition: object;
    wheelScale_2: object;
    wheelRotation: object;
    wheelScale_1: object;
    wheelPosition_1: object;
    wheelScale_3: object;
    wheelScale_4: object;
    wheelScale_copy: object;
    wheelPosition_copy: object;
    wheelScale_2_copy: object;
    wheelScale_1_copy: object;
    pointerRotation_copy_copy: object;
    wheelPosition_1_copy: object;
    wheelScale_3_copy: object;
    wheelScale_4_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Ad_Spin_Idle {
  Layout: {
    pointer: object;
    wheelContainer: object;
  };

  BlockTypeByName: {
    setPointerAngle: object;
    wheelScale: object;
    wheelScale_2: object;
    wheelScale_1: object;
    wheelScale_3: object;
    wheelScale_4: object;
    wheelScale_copy: object;
    wheelScale_2_copy: object;
    wheelScale_1_copy: object;
    wheelScale_3_copy: object;
    wheelScale_4_copy: object;
  };

  flowData = raw.animations[1];
}
